import type { TranslationKey } from "../locales";
import { LocalizedError, type LocalizedErrorOptions } from "./localized-error";

/**
 * The request carries no caller the server can act for: no session, a terminal token that names
 * no pairing, a signed-in user with no organisation in scope. 401, code `unauthorized`.
 *
 * The clients never toast it — a 401 is a sign-in problem, and the session handling answers it —
 * and the middleware records every one in `statusAlerts`.
 */
export class UnauthorizedError extends LocalizedError {
	readonly status = 401 as const;
	readonly code: string;

	constructor(key: TranslationKey = "general.unauthorized", options?: LocalizedErrorOptions) {
		super(key, options);
		this.name = "UnauthorizedError";
		this.code = options?.code ?? "unauthorized";
	}
}
